import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {useServerResume} from 'features/server/model/useServerMutations';
import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import {ExceededModal} from 'entities/user';
import IServerOutput from 'features/server/model/Server/IServer';

interface IServerResumeModalProps {
    item: IServerOutput,
    open: boolean;
    handleClose: () => void;
}

const ServerResumeModal: React.FC<IServerResumeModalProps> = ({ item, open, handleClose }) => {
    const {resume, isLoading, isExceededOpen, closeExceeded} = useServerResume({uuid: item.uuid, handleClose});

    return (
        <>
            <ConfirmModal
                variant="resume"
                open={open}
                handleClose={handleClose}
                header={t`Возобновление сервера`}
                title={<Trans id="modal.server.resume.title" message="Вы уверены, что хотите возобновить сервер"/>}
                name={item.name}
                confirmText={t`Возобновить`}
                onConfirm={resume}
                isLoading={isLoading}
            />
            <ExceededModal
                isOpen={isExceededOpen}
                handleClose={closeExceeded}
                type="servers"
            />
        </>
    );
};

export default ServerResumeModal;
